export default "__VITE_ASSET__Cf16gyzF__"